import type { AstroCommandServices } from '@wix/cli-command-contract';
import { isLoggedInToAccount } from '@wix/cli-auth';
import { createHttpClient } from '@wix/cli-http-client';
import { createPetriOverridesCookie } from '@wix/cli-astro-definitions';
import { CliError, CliErrorCode } from '@wix/cli-error';
import type { ProjectModel } from '../model.js';
import { log } from './logger.js';
import { buildGenerateExtensionsSchema } from '../components/GenerateCommand/generate-schema/generateSchema.js';
import type { GenerateExtensionType } from '../components/GenerateCommand/extensionHandlers.js';

export async function nonInteractiveSchemaGenerateExtensions(
  _services: AstroCommandServices,
  model: ProjectModel,
  options: { type?: GenerateExtensionType } = {}
) {
  const authData = await isLoggedInToAccount();
  if (!authData) {
    throw new CliError({
      code: CliErrorCode.AuthenticationRequired(),
      cause: null,
    });
  }

  const httpClient = createHttpClient({
    type: 'backoffice',
    getAppToken: () => authData.getAccessToken({}),
    cookies: createPetriOverridesCookie(model.config.httpExperiments),
  });

  const schema = await buildGenerateExtensionsSchema(httpClient, options.type);

  log(JSON.stringify(schema));
}
